import { useLocation } from "react-router-dom";

function useQueryString(key) {
  return new URLSearchParams(useLocation().search).get(key);
}

export { useQueryString };
